import { mergeClasses } from '@blank/utilities'
import { Skeleton, SkeletonProps } from '../Skeleton/Skeleton'

export const MessageSkeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <Skeleton
      className={mergeClasses('h-14 w-full rounded-lg', className)}
      {...props}
    />
  )
}
